import CIMSComment from 'components/CIMSComment'
import React from 'react'
import CIMSFormItem from 'components/CIMSFormItem'
import {
  useGenericComment,
  UseGenericCommentOptions,
} from 'components/CIMSComment/hooks/useGenericComment'

export const CommentFormItem: React.VFC<
  Pick<UseGenericCommentOptions, 'required'>
> = ({ required }) => (
  <CIMSFormItem {...useGenericComment({ required })}>
    <CIMSComment />
  </CIMSFormItem>
)
